import { alpha } from '@mui/material';
import { createMuiStyles } from '../../../../utils/mui';

export const sliderStyles = createMuiStyles({
  container: {
    pt: {
      xs: 0,
      md: 10,
    },
    mb: 10,
    pb: {
      xs: 3,
    },
    '.swiper-pagination': {
      display: 'flex',
      gap: '0.5rem',
      flexDirection: {
        md: 'column',
      },
      justifyContent: 'center',
      width: {
        xs: 1,
        md: 'auto',
      },
      left: {
        xs: 0,
        md: 'auto',
      },
      right: {
        md: 'calc(var(--container-fluid-padding) / 2)',
      },
      top: {
        md: '50%',
      },
      bottom: {
        xs: '0',
        md: 'auto',
      },
      transform: {
        md: 'translate(50%, -50%)',
      },
      '.swiper-pagination-bullet': {
        outline: 'none',
        transition: '0.3s',
        '&.swiper-pagination-bullet-active': {
          height: {
            md: '1.25rem',
          },
          width: {
            xs: '1.25rem',
            md: '0.5rem',
          },
          borderRadius: '0.25rem',
        },
      },
    },
  },
  imageContainer: {
    pr: {
      md: 'var(--container-fluid-padding)',
    },
  },
  image: {
    height: '30rem',
    borderRadius: {
      md: 2,
    },
    width: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    objectFit: 'cover',
    objectPosition: 'center',
    boxShadow: 15,
    bgcolor: (theme) => alpha(theme.palette.common.black, 0.11),
  },
  contentContainer: {
    pb: 2.5,
    px: 'var(--container-fluid-padding)',
  },
  detail: {
    display: 'block',
    maxWidth: {
      lg: 4 / 5,
    },
  },
});
